export default "__VITE_ASSET__2c77e8fa__"